import * as Styled from 'components/ToolkitV2/CardV2/components/Price/Price.styled';

import { PriceTypes } from 'components/AdForm/types';
import { CURRENCIES } from 'types';
import type { PriceProps } from 'components/ToolkitV2/CardV2/components/Price/Price.typed';

function Price(props: PriceProps) {
  const {
    price,
    oldPrice,
    currency,
    pricePerMonth,
    priceOnRequest,
    flip,
    isGrid,
    displayLabels = true,
  } = props;

  const currencyDisplay = currency === CURRENCIES.GBP ? '£' : '€';

  const priceDisplay = price ? `${currencyDisplay}${price}` : 'No Price';

  const pricePerMonthDisplay = pricePerMonth
    ? `${currencyDisplay}${pricePerMonth}`
    : 'n/a';

  const oldPriceDisplay = oldPrice ? `${currencyDisplay}${oldPrice}` : 'n/a';

  return (
    <Styled.Container>
      <Styled.PriceContainer>
        <Styled.PriceLabelWrapper flip={flip}>
          {displayLabels && (
            <Styled.Label isGrid={isGrid}>
              <span>Price&nbsp;</span>
            </Styled.Label>
          )}
          {oldPrice && <Styled.PriceDrop>{oldPriceDisplay}</Styled.PriceDrop>}
        </Styled.PriceLabelWrapper>
        <Styled.Text isGrid={isGrid}>
          {!priceOnRequest ? priceDisplay : PriceTypes.ON_REQUEST}
        </Styled.Text>
      </Styled.PriceContainer>
      {pricePerMonth && (
        <Styled.NextToPriceContainer>
          <Styled.PriceLabelWrapper>
            {displayLabels && <Styled.Label isGrid={isGrid}>From</Styled.Label>}
          </Styled.PriceLabelWrapper>
          <Styled.Text isGrid={isGrid}>
            {pricePerMonthDisplay}&nbsp;
            <Styled.PPMDisplay>p/m</Styled.PPMDisplay>
          </Styled.Text>
        </Styled.NextToPriceContainer>
      )}
    </Styled.Container>
  );
}

export { Price };
